import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { COMPONENT_TYPE } from '@/courses/values/courses.values';
import { ContentType } from '@/content/types/content.types';
import { SECTION_TYPES } from '@/content/values/sections';
import { ClassesService } from '@/classes/services/classes.service';
import { SectionsProvider } from '@/content/providers/sections.provider';


@Component({
  name: 'ed-content-section-controls',
  components: {
    EdPresentationModeNavigationToggle: () => import(/* EdPresentationModeNavigationToggle */'@/content/components/ed-presentation-mode/ed-presentation-mode-navigation-toggle/ed-presentation-mode-navigation-toggle.component.vue')
  }
})
export default class EdContentSectionControlsComponent extends Vue {

  @Prop({ default: null }) readonly contentId: number;
  @Prop({ default: null }) readonly classId: number;
  @Prop({ default: '' }) readonly componentName: string;
  @Prop({ default: '' }) readonly label: string;
  @Prop({ default: false }) readonly hasLessonCounter: boolean;
  @Prop({ default: 0 }) readonly lessonCounter: boolean;
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: false }) readonly hasEditButton: boolean;
  @Prop({ default: true }) readonly hasCloseSidebarButton: boolean;
  @Prop({ default: true }) readonly hasPresentationModeNavigation: boolean;
  @Prop({ default: COURSE_MODE.VIEWER }) readonly mode: COURSE_MODE;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: () => [] }) readonly menuAddOptions: any[];
  @Prop({ default: false }) readonly hasAddButton: boolean;
  @Prop({ default: false }) readonly hasCalendar: boolean;

  public isEditionMode: boolean = false;
  public readonly onModeChanged: string = 'onModeChanged';
  public readonly onAdd: string = 'onAdd';
  public readonly onToggleSidebar: string = 'onToggleSidebar';
  readonly onSelectAddOption: string = 'onSelectAddOption';

  get articleClass() {
    return {
      'mode--viewer': !this.isEditionMode,
      'mode--edition': this.isEditionMode
    }
  }

  get isPresentationModeTeacher(){
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get canChangeMode() {
    const isNotPresentationMode = !this.isPresentationModeTeacher;
    const isNotStudent = !this.$store.getters['AuthStore/isStudent'];
    const isSubstituteTeacher = this.$store.getters['AuthStore/isSubstituteTeacher'];
    const isSubstituteTeacherWithPermissions = isSubstituteTeacher && this.$store.state.ClassesStore.substituteTeacherCanEditClass.get(this.classId);
    
    if (this.hasEditButton && isNotPresentationMode && isNotStudent) {
      if (isSubstituteTeacher && this.classId && this.classId > 0) {
        return isSubstituteTeacherWithPermissions;
      }

      return true;
    }

    return false;
  }

  get isPresentationNavigation() : boolean {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  setEditionMode() {
    this.isEditionMode = this.mode === COURSE_MODE.EDIT; 
  }

  onEditionModeChanged() {
    const mode = this.isEditionMode ? COURSE_MODE.EDIT : COURSE_MODE.VIEWER;
    this.$Courses.Store.setCourseMode({
      mode,
      courseId: this.contentId
    })
    if(!this.isEditionMode) {
      if(this.componentName != COMPONENT_TYPE.OBJECT_PREVIEW.code) {
        let selectInfo = { 
          courseId: this.contentId, 
          classId: this.classId, 
          componentInfo: { 
            name: null,
            section: null,
            edition: false 
          }
        };
        this.$Courses.Store.setComponentSelected(selectInfo)
      }
    }
    this.$emit(this.onModeChanged, mode);
  }

  goToAdd() {
    this.$emit(this.onAdd);
  }

  toggleSidebar() {
    this.$App.Store.toggleSidebar()
    this.$emit(this.onToggleSidebar);
  }

  toggleMode() {
    this.isEditionMode = !this.isEditionMode;
    this.onEditionModeChanged();
  }

  triggerAdd(optionSelected) {
    switch(optionSelected.code) {
      case SECTION_TYPES.SECTION_LESSON.code: 
        this.$emit(this.onAdd, null, true);
      break;
      case SECTION_TYPES.LESSON_ZIP.code: 
        this.$emit(this.onSelectAddOption, optionSelected);
      break;
      default: 
        this.$emit(this.onAdd);
      break;
    }
  }

  onCalendarSelected() {
    this.$emit('onCalendarSelected');
  }

  created() {
    this.setEditionMode();
  }

}